import React, { useEffect, useState } from 'react'
import './flightMob.css';
import { 
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Box,
  Container,
  Typography,
  Button,
  Menu,
  MenuItem,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ToCitySelect from './ToCitySelect';
import { ToCityContext } from '../../contexts/ToCityContext';
import { FromCityContext } from '../../contexts/FromCityContext';
import FromCitySelect from './FromCitySelect';
import { useNavigate } from 'react-router';
import { useUserAuth } from '../login/userAuthContext';
import FlightMenu from '../dropdowns/dropflightCity';


const months = ["Jan'", "Feb'", "Mar'", "April", "May", "June", "July", "Aug'", "Sept'", "Oct'", "Nov'", "Dec'"];
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]


const saerchBtnStyle = {
  fontSize: '14px',
  borderRadius: '30px',
  width: '100px',
  marginBottom:'50px'
}

export default function FlightMobile() {
  const [toCityClick, setTocityClick] = useState(true);
  const [fromCityClick, setFromCityClick] = useState(true);
  const [value, setValue] = useState('one');
  const [discount, setDiscount] = useState('regular');
  const navigate = useNavigate();
  const {user} = useUserAuth();
  const [start, setStart] = useState({
    City: "Delhi",
    airport: "DEL Delhi Airport India"
  });
  const [dest, setDest] = useState({
    City: "Bengaluru",
    airport: "BLR Bengaluru International Airport"
  });
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const [date,setDate] = useState();
  const [userDate, setUserDate] = useState(new Date());
  useEffect(()=>{
    setUserDate(new Date(date));
  }, [date]);

  function CityCrad(props){
    const handleCityClick = ()=> {
      if(props.initial==='From'){
        setTocityClick(true);
      }else if(props.initial==='To'){
        setFromCityClick(true);
      }
    }
    return <div className='flight-mob' onMouseOver={handleCityClick}>
      <Typography variant='body2' fontSize='14px' paddingBottom='20px' onMouseOver={handleCityClick}>{props.initial}</Typography>
      <Typography variant='h1' fontSize='30px' fontWeight='bolder' onMouseOver={handleCityClick}>{props.cityName}</Typography>
      <Typography variant='body2' fontSize='10px' onMouseOver={handleCityClick}>{props.airport}</Typography>
    </div>
  }
  function DateCard(props){
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleDates = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = ()=>{
    setAnchorEl(null);
  }
  const handleDateSetting = (e)=>{
    e.persist();
    if(props.showDate){
      setDate(e.target.value);
    }else{
      return;
    }
    
  }
  useEffect(()=>{
    setAnchorEl(null);
  }, [date])
    return <div className='flight-mob'>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleDates}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none'}}
      >
        {props.option}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem><input type='date' onChange={handleDateSetting}/></MenuItem>
      </Menu>
      {props.showDate && 
        <div>
        {date ? <>
          <Box display='flex'>
          <Typography variant='h1' fontSize='40px'>{userDate.getDate()}</Typography>
          <Typography variant='h3' fontSize='23px'>{months[userDate.getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px'>{userDate.getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[userDate.getDay()]}</Typography>
        </> : 
        <>
          <Box display='flex'>
          <Typography variant='h1' fontSize='40px'>{new Date().getDate()}</Typography>
          <Typography variant='h3' fontSize='23px'>{months[new Date().getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px'>{new Date().getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[new Date().getDay()]}</Typography>
        </>
        }
      </div>
      }
      {!props.showDate && <Typography variant='body2' fontWeight='bold' textAlign='left' sx={{padding:'10px'}}>Add a return date for bigger discount</Typography>}
    </div>
  }
  const [passanger, setPassanger] = useState(1);
  const traveller = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  function Traveller(){
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
      setAnchorEl(null);
    }
    const handlePassangers = (e)=>{
      setPassanger(e.target.value);
      setAnchorEl(null);
    }
    return <div className='flight-mob'>
       <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpen}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none'}}
      >
        Travellers & Class
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{width:'70vw'}}
      >
        <MenuItem sx={{width:'70vw'}}>
        <Box 
        display='flex'
        sx={{width:'70vw', justifyContent:'space-around'}}
        >
          <Typography variant='body2' fontWeight='bold'>Travellers</Typography>
          <select onChange = {handlePassangers}> {traveller.map(el=>{
            return <option key={el} value={el}>{el}</option>
        })
        }</select>
        </Box>
        </MenuItem>
      </Menu>
      <h3><span style={{fontSize:'30px', lineHeight:'0.2'}}>{passanger}</span>Traveller</h3>
      <Typography variant='body1' fontWeight='500'>Economy/Premium economy</Typography>
      
    </div>
  }
  const handleDiscount = (e)=> {
    setDiscount(e.target.value);
  }
  const handleTickets = ()=> {
    if(user){
      navigate('/tickets/flight')
    }else if(!user){
      navigate('/login');
    }
  }
  function setterFunc1(args){
    setStart(args)
  }
  function Trips() {
    const [alignment, setAlignment] = useState('one');
  
    const handleChange = (event, newAlignment) => {
      setAlignment(newAlignment);
    };
  
    return (
      <ToggleButtonGroup
        color="primary"
        value={alignment}
        exclusive
        onChange={handleChange}
        aria-label="Platform"
        sx={{marginTop:'20px'}}
      >
        <ToggleButton value="one">One Way</ToggleButton>
        <ToggleButton value="round">Round Trip</ToggleButton>
        <ToggleButton value="multi">Multi City</ToggleButton>
      </ToggleButtonGroup>
    );
  }
  return (
    <div>
      <div className='flight-card-mob'>
      <Container>
        <Trips />
      </Container>
      <div className='slider-mob'>
        <Container>
          <Box display='flex'
          sx={{flexDirection:'column', gap: '20px'}}
          >
            <CityCrad initial={'From'} cityName={start.City} airport={start.airport} />
            <>{toCityClick && 
              <div className='to-position'>
              {toCityClick && <FlightMenu setterFunc={setterFunc1} removeMenu={setTocityClick}/>}
              </div>
              }</>
            <CityCrad initial={'To'} cityName={dest.City} airport={dest.airport} />
            <>{fromCityClick && 
            <div className='from-position'>
              {fromCityClick && <FlightMenu setterFunc={setDest} removeMenu={setFromCityClick} />}
            </div>
            }</>
            <DateCard option={'Departure'} showDate={true}/>
            <DateCard option={'Return'} showDate={false} />
            <Traveller />
          </Box>
        </Container>
      </div>
      <Container>
        <FormControl component="fieldset">
          <FormLabel component="legend"> </FormLabel>
          <RadioGroup name="tour" value={discount} onChange={handleDiscount}>
          <Box
          display='flex'
          sx={{paddingTop: '10px'}}
          className="radioWrap"
          >
            <FormControlLabel value="regular" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label={<Typography variant='body2' fontSize='12px'>Regular<br />Fares</Typography>}/>
            <FormControlLabel value="armed" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label={<Typography variant='body2' fontSize='12px'>Armed Forces<br />Fares</Typography>} />
            <FormControlLabel value="student" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label={<Typography variant='body2' fontSize='12px'>Student<br />Fares</Typography>} />
            <FormControlLabel value="senior" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label={<Typography variant='body2' fontSize='12px'>Senior Citizen<br />Fares</Typography>} />
            <FormControlLabel value="doc" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label={<Typography variant='body2' fontSize='12px'>Doctos & Nurses<br />Fares</Typography>} />
            <FormControlLabel value="double" control={<Radio checkedIcon={<CheckCircleRoundedIcon />}/>} label={<Typography variant='body2' fontSize='12px'>Double seat<br />Fares</Typography>} />
          </Box>
          </RadioGroup>
        </FormControl>
      </Container>
      <Container><Button variant='contained' sx={saerchBtnStyle} onClick={handleTickets}>SEARCH</Button></Container>
    </div>
    
    </div>
  )
}
